var getConfigurations = () => {
  return require(`./${process.env.VUE_APP_COUNTRY_CODE}.js`)
}

const configs = getConfigurations()

const referralLink = configs.referralLink

const dashboardGetUpdatedItems = configs.dashboardGetUpdatedItems

const dashboardContactTheTeamItems = configs.dashboardContactTheTeamItems

const dashboardOtherItems = configs.dashboardOtherItems

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
